module.exports = __webpack_public_path__ + "static/img/FQA_ZH_2.76f9677.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/FQA_ZH_2.png
// module id = nvGS
// module chunks = 4